import clsx from "clsx"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import type { DictionaryStoryblok } from "~/@types/storyblok-generated"
import { ClientTranslate } from "~/providers/I18nProvider/ClientTranslate"

import * as css from "./styles.css"

export type GiftMessageProps = PropsWithClassName<{
  message: Nullish<string>
  to: Nullish<string>
  from: Nullish<string>
}>

function GiftMessage({ className, message, to, from }: GiftMessageProps) {
  const giftFields: { value: Nullish<string>; tKey: keyof DictionaryStoryblok }[] = [
    { value: to, tKey: "cart_gift_message_to" },
    { value: from, tKey: "cart_gift_message_from" },
    { value: message, tKey: "cart_gift_message_message" },
  ]

  return (
    <ul className={clsx(className, css.GiftMessage)}>
      {giftFields.map(
        ({ value, tKey }) =>
          value && (
            <ClientTranslate key={tKey} className={css.item} tKey={tKey} as="li">
              <span className={css.blueDeep}> : {value}</span>
            </ClientTranslate>
          )
      )}
    </ul>
  )
}

export default GiftMessage
